module.exports = __webpack_public_path__ + "static/open-sans-regular-de0869e324680c99efa1250515b4b41c.woff";